/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-02",
    versionChannel: "nightly",
    buildDate: "2023-03-02T00:19:36.326Z",
    commitHash: "fcaa17308cfafe88ed2850a14be8e52293082633",
};
